import React from "react";
import { useTranslation } from "react-i18next";
import {
  PassBooleanControl,
  PassSettingSwitch,
  PassSettingSwitchThumb,
} from "./passSettingsV2.styled";
import { SystemSettingRow } from "./systemSettingRow.component";

export const AllowEditTimeStampClockSetting: React.FC<{
  value: boolean;
  onChange: (v: boolean) => void;
}> = ({ value, onChange }) => {
  const { t } = useTranslation();

  return (
    <SystemSettingRow
      title={t("ProfileCompany.LocalStampClockAllowEditTime")}
      description={t("ProfileCompany.LocalStampClockAllowEditTimeInfo")}
      controlVerticalAlign="center"
    >
      <PassBooleanControl>
        <PassSettingSwitch
          type="button"
          $active={value}
          aria-label={t("ProfileCompany.LocalStampClockAllowEditTime")}
          aria-pressed={value}
          onClick={() => onChange(!value)}
        >
          <PassSettingSwitchThumb $active={value} />
        </PassSettingSwitch>
      </PassBooleanControl>
    </SystemSettingRow>
  );
};
